module.exports = __webpack_public_path__ + "static/media/apartment15.77ac93df.jpg";